export default __webpack_public_path__ + "static/media/347.1dd1467c.gif";